export const lineHasAtLeastTwoDistinctPoints = (geometry) => {
    const coords = geometry?.getCoordinates?.();
    if (!Array.isArray(coords) || coords.length < 2) {
        return false;
    }

    const first = coords[0];
    if (!Array.isArray(first) || first.length < 2) {
        return false;
    }

    // Common OL sketch case: after the first click it may emit [p, p].
    // Treat that as incomplete so we don't validate/notify too early.
    for (let i = 1; i < coords.length; i += 1) {
        const p = coords[i];
        if (!Array.isArray(p) || p.length < 2) {
            continue;
        }
        if (p[0] !== first[0] || p[1] !== first[1]) {
            return true;
        }
    }

    return false;
};

export const isIncompleteLineString = (geometry) => !lineHasAtLeastTwoDistinctPoints(geometry);
